/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-11-15 13:46:42
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-18 20:19:46
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Space, Tabs } from 'antd'
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { selectEdition, selectInsuranceArray } from '../../../app/applicationSlice'
import { RootDispatch } from '../../../app/store'
import { TabPane } from '../../../compnents/widgets/TabBar'
import { selectMenus } from '../../../layouts/layoutSlice'
import { SettingInsurance } from '../../user/setting/settingInsurance'
import styles from '../functionSettingTabs.module.css'
import { SettingAppointment } from './appointmentSettings/appointmentSettings'
import { FeeSettings } from './feeSettings/feeSettings'
import { OutpatientSetting } from './outpatientSettings/outpatientSettings'
import { ShiftSchedulingSettings } from './shiftSchedulingSettings/shiftSchedulingSettings'
import { StatisticalSettings } from './statisticalSettings/statisticalSettings'
import { WarehouseSetup } from './warehouseSetup/warehouseSetup'
import { AISettings } from './AISetting/AISetting'

export const FunctionSettingPage = (props: {
  selectedTab?: any
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const location: any = useLocation()

  const menus = useSelector(selectMenus)

  const pbszFlag = menus?.filter((v) => {
    return v?.name == '排班'
  })

  const yyszFlag = menus?.filter((v) => {
    return v?.name == '预约'
  })

  const [selectedTab, setSelectedTab] = useState<any>(
    pbszFlag?.length ? '1' : yyszFlag?.length ? '2' : '3'
  )

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const insuranceArray = useSelector(selectInsuranceArray)

  return (
    <Col className={styles.contentMain}>
      <Tabs
        tabPosition={'left'}
        onChange={(v) => {
          setSelectedTab(v)
        }}
      >
        {pbszFlag?.length ? (
          <TabPane key='1' tab='排班设置'>
            <ShiftSchedulingSettings
              selectedTab={selectedTab}
            ></ShiftSchedulingSettings>
          </TabPane>
        ) : (
          <></>
        )}
        {yyszFlag?.length ? (
          <TabPane key='2' tab='预约设置'>
            <SettingAppointment selectedTab={selectedTab}></SettingAppointment>
          </TabPane>
        ) : (
          <></>
        )}
        <TabPane key='3' tab='门诊设置'>
          <OutpatientSetting selectedTab={selectedTab}></OutpatientSetting>
        </TabPane>
        <TabPane key='4' tab='收费设置'>
          <FeeSettings selectedTab={selectedTab}></FeeSettings>
        </TabPane>
        <TabPane key='5' tab='库房设置'>
          <WarehouseSetup selectedTab={selectedTab}></WarehouseSetup>
        </TabPane>
        <TabPane key='6' tab='统计设置'>
          <StatisticalSettings selectedTab={selectedTab}></StatisticalSettings>
        </TabPane>

        {insuranceArray?.length > 0 ? (
          <>
            <TabPane key='7' tab='医保设置'>
              <SettingInsurance selectedTab={selectedTab} />
            </TabPane>
          </>
        ) : (
          <></>
        )}
        <TabPane key='8' tab='AI 设置'>
          <AISettings selectedTab={selectedTab}></AISettings>
        </TabPane>
      </Tabs>
    </Col>
  )
}
